<template>
  <List
    :config="blockData.config"
    :initial-data="blockData.initialData"
    state-in-url
  >
    <template #entries="{ entries }">
      <TileView
        ref="tilesContainer"
        :tiles="entries"
        :grid-type="ETileGridType.SINGLE"
      />
    </template>
    <template #no-entries>
      <NoEntries :type-handle="blockData.typeHandle" />
    </template>
    <template #loader>
      <LoaderTileRow></LoaderTileRow>
      <LoaderTileRow class="mt-md"></LoaderTileRow>
    </template>
  </List>
</template>

<script setup lang="ts">
import { ETileGridType } from '@/@types/tile-grid-type';
import { scrollToElement } from '@/helpers/scroll';
import LoaderTileRow from '@/components/loader/tile-row.vue';
import NoEntries from '../../components/noEntries/vdv/no-entries.vue';
import TileView from '@/components/components/views/tileView/tile-view.vue';
import { SSR_safe_mq_breakpointIsMobile } from '@/injectionSymbols';
import type { OfferListData } from '../blockType';
import List from '@/components/components/advancedList/list.vue';

const props = defineProps({
  blockData: {
    type: Object as PropType<OfferListData>,
    required: true,
    default: {} as OfferListData,
  },
});

const isMobile = inject(SSR_safe_mq_breakpointIsMobile);
const router = useRouter();

// scroll to list if filter is set in url query
onMounted(async () => {
  if (
    router.currentRoute?.value.query &&
    Object.keys(router.currentRoute.value.query).length
  ) {
    const element = document.getElementById(props.blockData.id);
    scrollToElement(element, isMobile ? 0 : 120);
  }
});
</script>
